import React from 'react';
import getReportResults from './getReportResults';
import getTextoBase from './getTextoBase';
import PieChartRecharts from '../Charts/PieChartRecharts';
import BarChartReports from '../Charts/BartChartReports';
import BarChartwRefLine from '../Charts/BarChartwRefLine';
import BarChartStacked from '../Charts/BarChartStacked';
import BarChartMulti from '../Charts/BarChartMulti';
import DatatableReports from '../Datatables/DatatableReports';
import SpinnerContent from '../common/components/SpinnerContent';
import { DEBUG } from '../config';

class ReportChart extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            studyId: props.studyId,
            studyName: props.studyName,
            quadroId: props.quadroId,
            username: props.username,
            token: props.token,
            quadros: props.quadros,
            quadrosTexto: props.quadrosTexto,
            quadro: null,
            nomeQuadro: "",
            isBarChart: false,
            isMultiBarChart: false,
            isPie: false,
            isStacked: false,
            chartLabel: "",
            tableLabel: "",
            labelTooltip: "",
            textoBase: "",
            textoBaseAdicional: "",
            textoNota: "",
            apresentaGrafico: false,
            apresentaTabela: false,
            apresentaMedia: false,
            apresentaNps: false,
            data: [],
            chartData: [],
            precisaoGrafico: 0,
            totalMediaNps: 0.0,
            drillDown: false,
            dashBoard: props.dashBoard,
            gotData: false,
            tableColumnName: "",
            tableColumTitles: [],
            tableRowName: "",
            tableRows: [],
            precisaoTabela: 0,
            valorBase: "",
        }
        
        this.initializeState = this.initializeState.bind(this);
        this.getResults = this.getResults.bind(this);
        this.buildChartData = this.buildChartData.bind(this);
        this.buildMediaNpsChart = this.buildMediaNpsChart.bind(this);
        this.buildPieOrBarchart = this.buildPieOrBarchart.bind(this);
        this.buildStacketChart = this.buildStacketChart.bind(this);
    }

    buildMediaNpsChart() {
        var chartDataAux = [];
        var valor = 0;

        var colunas = this.state.data[0].reportResultsByColumn;
        var colunaTotal = colunas.find((col) => col.coluna === "TOTAL");

        if (this.state.apresentaMedia) {
            let mediaRaw = colunaTotal ? colunaTotal.media : 0;
            var totalMediaValue = parseFloat(Number(mediaRaw) || 0).toFixed(2);
            this.setState({ totalMediaNps: totalMediaValue });
        } else if (this.state.apresentaNps) {
            let npsRaw = colunaTotal ? colunaTotal.nps : 0;
            var totalNpsValue = parseFloat(Number(npsRaw) || 0).toFixed(0);
            if (totalNpsValue==='-0'){
                totalNpsValue=0;
            }
            this.setState({ totalMediaNps: totalNpsValue });
        }
        var colunasSemTotal = colunas.filter((col) => col.coluna !== "TOTAL");
        for (let i = 0; i < colunasSemTotal.length; i++) {
            var newRow = { name: colunasSemTotal[i].coluna };
            if (this.state.apresentaMedia) {
                valor = colunasSemTotal[i].media || 0;
                valor = Number(valor) || 0;
                valor = parseFloat(valor).toFixed(2);
            } else if (this.state.apresentaNps) {
                valor = Number(colunasSemTotal[i].nps) || 0;
                valor = parseFloat(valor).toFixed(0);
                if (valor==='-0'){
                    valor=0;
                }
            }
           
            newRow[this.state.labelTooltip] = parseFloat(valor);
            chartDataAux[i] = newRow;
        }
        return chartDataAux;
    }

buildPieOrBarchart(quadroAtual) {
        var chartDataAux = [];
    if (!quadroAtual || !this.state.data) return [];

    for (let i = 0; i < this.state.data.length; i++) {
        var newRow = { name: this.state.data[i].linha || "N/A" };
        var colunas = this.state.data[i].reportResultsByColumn;
        var valorRaw = 0;

        if (colunas) {
            var colunaTotal = colunas.find((q) => q.coluna === "TOTAL");
            if (colunaTotal) {
                switch (Number(quadroAtual.gValores)) {
                    case 1: valorRaw = colunaTotal.pv; break;
                    case 3: valorRaw = colunaTotal.ph; break;
                    case 2: valorRaw = colunaTotal.valorBase; break;
                    default: valorRaw = colunaTotal.valorBase; 
                        break;
                }
            }
        }

        // Forçar conversão e garantir que nunca é NaN ou null
        var valorNum = Number(valorRaw) || 0;
        newRow[String(this.state.labelTooltip).trim()] = parseFloat(valorNum.toFixed(this.state.precisaoGrafico));
        
        chartDataAux[i] = newRow;
    }
    return chartDataAux;
    }

buildStacketChart(quadroAtual) {
        var chartDataAux = [];
        if (!quadroAtual || !this.state.data) return [];

        for (let i = 0; i < this.state.data.length; i++) {
            // Garante que o 'name' (Eixo Y) é sempre uma String limpa
            var newRow = { name: String(this.state.data[i].linha || "N/A") }; 
            
            var colunas = this.state.data[i].reportResultsByColumn;
            
            if (colunas) {
                var colunasSemTotal = colunas.filter((q) => q.coluna !== "TOTAL");
                for (let j = 0; j < colunasSemTotal.length; j++) {
                    var valorRaw = 0;
                    
                    // Vai buscar o valor correto consoante as definições do quadro
                    switch (Number(quadroAtual.gValores)) {
                        case 1: valorRaw = colunasSemTotal[j].pv; break;
                        case 3: valorRaw = colunasSemTotal[j].ph; break;
                        case 2: valorRaw = colunasSemTotal[j].valorBase; break;
                        default: valorRaw = colunasSemTotal[j].valorBase; break;
                    }

                    // Força a conversão para número e garante precisão
                    var valorNum = Number(valorRaw) || 0;
                    var valorFormatado = parseFloat(valorNum.toFixed(this.state.precisaoGrafico));
                    
                    //Garante que o nome da coluna é uma String limpa sem espaços extra
                    var nomeColuna = String(colunasSemTotal[j].coluna).trim(); 
                    
                    newRow[nomeColuna] = valorFormatado;
                }
            }
            chartDataAux[i] = newRow;
        }
        return chartDataAux;
    }

    buildChartData(quadroAtual) {
        if (!quadroAtual || !this.state.data || this.state.data.length === 0) return;

        var chartDataAux = [];
        
        // Usamos as variáveis locais do quadroAtual em vez do this.state para garantir sincronia
        const isStackedLocal = quadroAtual.gTipo === 6;
        const isMultiBarLocal = quadroAtual.gTipo === 1;

        if (this.state.apresentaMedia || this.state.apresentaNps) {
            chartDataAux = this.buildMediaNpsChart();
        } else {
            if (isStackedLocal || isMultiBarLocal) {
                chartDataAux = this.buildStacketChart(quadroAtual);
            } else {
                chartDataAux = this.buildPieOrBarchart(quadroAtual);
            }
        }
        this.setState({ chartData: chartDataAux });
    }

    initializeState(results) {
        const currentQuadroId = this.props.quadroId; 
        var quadro = this.props.quadros.find((q) => String(q.id) === String(currentQuadroId));        
        if (!quadro) {
            console.warn(`Quadro com ID ${this.state.quadroId} não foi encontrado.`);
            return;
        }

        var quadroTexto = this.props.quadrosTexto.find((q) => String(q.id) === String(currentQuadroId));        var nomeQuadro = quadroTexto ? quadroTexto.nome : "";
        var textoNota = quadroTexto && quadroTexto.textoNota ? quadroTexto.textoNota : "";
        var textoBase = quadroTexto && quadroTexto.textoBase ? quadroTexto.textoBase : "";

        var isBarChart = Number(quadro.gTipo) === 2;
        var isMultiBarChart = Number(quadro.gTipo) === 1;
        var isPie = Number(quadro.gTipo) === 4;
        var isStacked = Number(quadro.gTipo) === 6;
        var drillDown = Number(quadro.gLinkedChart) === 1 && !this.props.dashBoard; // Usar prop aqui também
        var apresentaTabela = Number(quadro.apresentaTabela) === 1;
        var apresentaGrafico = Number(quadro.apresentaGrafico) === 1;
        // NOVA REGRA: Se o gráfico não tem valores definidos, herda da tabela!
        if (!quadro.gValores || Number(quadro.gValores) === 0) {
            if (Number(quadro.tApresentaPV) === 1) quadro.gValores = 1;
            else if (Number(quadro.tApresentaPH) === 1) quadro.gValores = 3;
            else if (Number(quadro.tApresentaValor) === 1) quadro.gValores = 2;
            else quadro.gValores = 2; // O valor absoluto fica como última rede de segurança
        }
        let apresentaMedia = false;
        let apresentaNps = false;
        let chartLabel = "";
        let labelTooltip = "";

        if (apresentaGrafico) {
            if (Number(quadro.gApresentaMedia) === 1) {
                chartLabel = "Valores médios";
                labelTooltip = "Média";
                apresentaMedia = true;
            } else if (Number(quadro.gApresentaNps) === 1) {
                chartLabel = "Net Promoter Score";
                apresentaNps = true;
                labelTooltip = "NPS";
            } else {
                if (Number(quadro.unidade) === 1) {
                    chartLabel = "Valores médios";
                    labelTooltip = "Média";
                } else {
                    switch (Number(quadro.gValores)) {
                        case 1: chartLabel = "Percentagens verticais (%)"; labelTooltip = "% vertical"; break;
                        case 3: chartLabel = "Percentagens horizontais (%)"; labelTooltip = "% horizontal"; break;
                        case 2: chartLabel = "Valores absolutos"; labelTooltip = "v. absoluto"; break;
                        default:
                            chartLabel = "Valores absolutos"; labelTooltip = "v. absoluto";
                            if (DEBUG){
                                console.warn(`ERRO [Report, ReportChart]: O tipo de valores (gValores) do quadro ID ${quadro.id} não está definido`, quadro.gValores);
                            }
                            break;
                    }
                }
            }
        }

        let tableLabel = "";
        if (apresentaTabela) {
            if (quadro.unidade === 1) tableLabel = "Valores médios";
            else if (quadro.tApresentaValor === 1) tableLabel = "Valores absolutos";
            else if (quadro.tApresentaPV === 1) tableLabel = "Percentagens verticais (%)";
            else if (quadro.tApresentaPH === 1) tableLabel = "Percentagens horizontais (%)";
        }

        let valorBase = "";
        if (this.state.dashBoard && results && results.length > 0) {
            var colsRow0 = results[0].reportResultsByColumn;
            var colTotalRow0 = colsRow0 ? colsRow0.find((c) => c.coluna === 'TOTAL') : null;
            if (colTotalRow0) {
                valorBase = " (" + Intl.NumberFormat('pt-PT', { useGrouping: true }).format(colTotalRow0.base) + ")";
            }
        }

        // 1º Guardamos tudo de uma vez
        this.setState({
            quadro, nomeQuadro, textoNota,
            textoBase: textoBase + this.state.textoBaseAdicional,
            isBarChart, isMultiBarChart, isPie, isStacked, drillDown,
            apresentaTabela, apresentaGrafico,
            precisaoGrafico: quadro.precisaoGrafico,
            precisaoTabela: quadro.precisao,
            apresentaMedia: apresentaMedia || (apresentaTabela && quadro.gApresentaMedia === 1),
            apresentaNps: apresentaNps || (apresentaTabela && quadro.gApresentaNps === 1),
            chartLabel, labelTooltip, tableLabel, valorBase
        }, () => {
            // 2º Quando o estado já está bem assente, construímos o gráfico!
            if (apresentaGrafico) {
                this.buildChartData(quadro);
            }
        });
    }

    getResults = async (username, token, studyId, quadroId) => {
        var results = await getReportResults(username, token, quadroId);
        if (DEBUG){
            console.log("DADOS QUE CHEGARAM DO JAVA:", results);
        }
        var textoBaseAdicional = await getTextoBase(username, token, studyId, quadroId);        
        
        if (typeof textoBaseAdicional === 'undefined' || textoBaseAdicional === null || textoBaseAdicional === "") {
            textoBaseAdicional="";
        }

        this.setState({textoBaseAdicional: textoBaseAdicional});

        this.setState({ gotData: true });
        return results;
    }

    componentDidUpdate = async (prevProps) => {
        if (this.props.quadroId !== prevProps.quadroId) {
            const results = await this.getResults(this.props.username, this.props.token, this.props.studyId, this.props.quadroId);
            this.setState({ data: results });
            this.initializeState(results);
        }
    }

    componentDidMount = async () => {
    if (typeof this.props.quadros !== 'undefined') {
        const results = await this.getResults(this.props.username, this.props.token, this.props.studyId, this.props.quadroId);
        // Usamos o callback do setState para garantir que gotData já é true
        this.setState({ data: results }, () => {
            this.initializeState(results);
        });
    }
}

    render() {
        return (
            <div>
                {!this.state.gotData &&
                    <SpinnerContent/>
                }                
                {this.state.gotData && (this.state.apresentaGrafico || this.state.apresentaTabela) && <h4>{this.state.nomeQuadro}</h4>}
                {this.state.gotData && (this.state.apresentaGrafico || this.state.apresentaTabela) && <hr />}
                {this.state.gotData && this.state.apresentaTabela && !this.state.dashBoard && <h6 style={{ textAlign: "right" }}><br/>{this.state.tableLabel}</h6>}
                {this.state.gotData && this.state.apresentaTabela && !this.state.dashBoard &&
                    <DatatableReports
                        studyName={this.state.studyName}
                        nomeQuadro={this.state.nomeQuadro}
                        dataTypeName={this.state.tableLabel}
                        precision={this.state.precisaoTabela}
                        data={this.state.data}
                        media={this.state.apresentaMedia}
                        nps={this.state.apresentaNps}
                        textoBase={this.state.textoBase}
                        textoNota={this.state.textoNota}
                    />}
                {this.state.gotData && this.state.apresentaGrafico && this.state.isPie &&
                    <PieChartRecharts
                        quadroId={this.state.quadroId}
                        dataTypeName={this.state.chartLabel}
                        textoNota={this.state.textoNota}
                        pieData={this.state.chartData}
                        valueKey={this.state.labelTooltip}
                        precision={this.state.precisaoGrafico}
                        drillDown={this.state.drillDown}
                        data={this.state.data}
                        chartLabel={this.state.chartLabel}
                    
                    />}
                {this.state.gotData && this.state.apresentaGrafico && this.state.isBarChart && !this.state.apresentaMedia && !this.state.apresentaNps &&
                    <BarChartReports
                        quadroId={this.state.quadroId}
                        dataTypeName={this.state.chartLabel}
                        textoNota={this.state.textoNota}
                        nomeY={this.state.labelTooltip}
                        barData={this.state.chartData}
                        drillDown={this.state.drillDown}
                        data={this.state.data}
                        chartLabel={this.state.chartLabel}
                    />
                }                
                {this.state.gotData && this.state.apresentaGrafico && this.state.isStacked &&
                    <div>
                        <h6 style={{ textAlign: "right" }}>{this.state.chartLabel}</h6>
                        <BarChartStacked
                            quadroId={this.state.quadroId}
                            dataTypeName={this.state.chartLabel}
                            textoNota={this.state.textoNota}
                            barData={this.state.chartData}                        
                        />
                    </div>
                }
                {this.state.gotData && this.state.apresentaGrafico && this.state.isMultiBarChart &&
                    <div>
                        <h6 style={{ textAlign: "right" }}>{this.state.chartLabel}</h6>
                        <BarChartMulti
                            quadroId={this.state.quadroId}
                            dataTypeName={this.state.chartLabel}
                            textoNota={this.state.textoNota}
                            barData={this.state.chartData}                        
                        />                        
                    </div>
                }
                {this.state.gotData && this.state.apresentaGrafico && (this.state.apresentaMedia || this.state.apresentaNps) &&
                    <div>
                        <h6 style={{ textAlign: "right" }}>{this.state.chartLabel}</h6>
                        <BarChartwRefLine
                            dataTypeName={this.state.chartLabel}
                            textoNota={this.state.textoNota}
                            chartData={this.state.chartData}
                            barDataKey={this.state.labelTooltip}
                            total={this.state.totalMediaNps} 
                            />                        
                    </div>
                    }
                {this.state.gotData && this.state.apresentaGrafico && this.state.dashBoard && <h6>{this.state.textoBase+this.state.valorBase}</h6>}
                {this.state.gotData && this.state.apresentaGrafico && <hr />}

            </div>
        );
    }
};
export default ReportChart;